import { Form, Formik } from "formik";
import * as Yup from "yup";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import TextField from "@components/Forms/FormInputs/TextField";

import { usePopupActions } from "@store/popupStore";

import userService from "../../services/user.service";

import "@fontsource/league-spartan/700.css";

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email address").required("Required"),
});

/**
 * Displays a form where a user can input their email to receive a password reset link.
 */
function ForgotPassword() {
  const PopupActions = usePopupActions();
  return (
    <div>
      <p>
        Please provide the email associated with your account so that we can
        <br />
        send you a link to reset your password.
      </p>
      <Formik
        initialValues={{
          email: "",
        }}
        onSubmit={async (values) => {
          await userService.sendPasswordResetEmail(values.email);
          PopupActions.closeModal();
        }}
        validationSchema={ForgotPasswordSchema}
      >
        {({ dirty, isSubmitting, isValid }) => (
          <Box component={Form} sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <TextField isFullWidth isRequired label="Email" name="email" type="email" />
            <Button disabled={!isValid || !dirty || isSubmitting} sx={{ mt: 3 }} type="submit" variant="contained">
              {isSubmitting ? <CircularProgress size={20} /> : <>Send Email</>}
            </Button>
          </Box>
        )}
      </Formik>
    </div>
  );
}

export default ForgotPassword;
